import {AsyncAction} from '../asyncUtilsTypes';
import {requestVeevaDocMetadata, requestVeevaMdpList, requestVeevaMdpModelLanguage, requestVeevaVeap} from './api';
import {Await} from '../types';

export enum VeevaActions {
  REQUEST_VEAP = 'VEEVA/REQUEST_VEAP',
  REQUEST_MDP_LIST = 'VEEVA/REQUEST_MDP_LIST',
  REQUEST_MDP_MODEL_LANGUAGE = 'VEEVA/REQUEST_MDP_MODEL_LANGUAGE',
  REQUEST_DOC_METADATA = 'VEEVA/REQUEST_DOC_METADATA',
}

export type VeevaAction =
  | AsyncAction<
      VeevaActions.REQUEST_VEAP,
      Await<ReturnType<typeof requestVeevaVeap>>,
      Parameters<typeof requestVeevaVeap>
    >
  | AsyncAction<
      VeevaActions.REQUEST_MDP_LIST,
      Await<ReturnType<typeof requestVeevaMdpList>>,
      Parameters<typeof requestVeevaMdpList>
    >
  | AsyncAction<
      VeevaActions.REQUEST_MDP_MODEL_LANGUAGE,
      Await<ReturnType<typeof requestVeevaMdpModelLanguage>>,
      Parameters<typeof requestVeevaMdpModelLanguage>
    >
  | AsyncAction<
      VeevaActions.REQUEST_DOC_METADATA,
      Await<ReturnType<typeof requestVeevaDocMetadata>>,
      Parameters<typeof requestVeevaDocMetadata>
    >;
